"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true
  });
  return <section data-section-id="257294" id="hero-section" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/home_renovation_construction_site.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/home_renovation_construction_site.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/home_renovation_construction_site.png-wvc-sizes" alt="Modern home renovation project with high-quality finishes" className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" />

      {}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[1px]"></div>

      {}
      <div ref={ref} className={`relative z-10 text-center px-4 md:px-8 max-w-5xl mx-auto flex flex-col items-center gap-8 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-white drop-shadow-2xl tracking-tight leading-tight">
          Your Trusted Home Renovation & Construction Experts
        </h1>
        <p className="font-default text-lg md:text-2xl text-white/95 drop-shadow-lg max-w-2xl font-medium">
          Quality craftsmanship for your dream home. Serving NJ & NY with excellence.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 mt-4">
          <Button asChild size="lg" className="bg-gradient-to-r from-primary to-secondary hover:from-primary-hover hover:to-secondary-hover text-white rounded-md px-8 py-6 text-lg shadow-strong transition-transform hover:scale-105">
            <Link to="/contact">Request Free Estimate</Link>
          </Button>
          
          <div className="flex flex-col gap-2">
            <Button asChild variant="outline" className="bg-slate-900/80 hover:bg-slate-900 text-white border-slate-700 rounded-md px-6 py-4 text-md shadow-md">
              <a href="tel:2017364633">201-736-4633</a>
            </Button>
            <Button asChild variant="outline" className="bg-slate-900/80 hover:bg-slate-900 text-white border-slate-700 rounded-md px-6 py-4 text-md shadow-md">
              <a href="tel:6464064601">646-406-4601</a>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/80 z-10">
        <ChevronDown className="w-8 h-8 drop-shadow-md" />
      </div>
    </section>;
}